<template>
	<div class="px-5">
		<v-col cols="12" class="py-0 group-bread-scrumb">
			<router-link :to="{ name: 'Promotion' }">
				Quản lý mã
			</router-link>
      <span> > </span>
      <router-link :to="{name: 'Promotion'}">
        Danh sách mã
      </router-link>
		</v-col>
		<div class="create-form">
			<v-col cols="12">
				<div class="justify-end d-flex">
					<v-btn class="btn-save" @click="create">
						<span>Tạo</span>
					</v-btn>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="group-form">
					<v-row>
						<v-col cols="12" class="py-0 box-header px-6">
							<v-row>
								<v-col cols="8" class="pt-5 px-8 col-bg">
									<h3>Danh sách mã giảm chung</h3>
								</v-col>
								<v-col cols="4" class="pt-5 d-flex col-bg">
									<v-text-field
										class="v-select-mini pt-0"
                    placeholder="Mã"
                    outlined
                    dense
                    maxLength="100"
										height="30px"
										@keyup.enter="getList(1)"
                    v-model="txtSearch"
                  ></v-text-field>
									<v-btn class="btn-save ml-3" small @click="getList(1)">
										<span>Tìm kiếm</span>
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" class="px-8 box-header-table">
              <div class="d-flex">
                <div class="col-code text-bold px-2 text-left col-bg">
                  Mã
                </div>
								<div class="col-type text-bold px-2 col-bg">
                  Loại
                </div>
								<div class="col-count-use text-bold px-2 text-center col-bg">
                  Số lượt sử dụng
                </div>
								<div class="col-count text-bold px-2 text-center col-bg">
                  Số lượng
                </div>
								<div class="col-count-used text-bold px-2 text-center col-bg">
                  Đã dùng
                </div>
                <div class="col-action text-bold text-center col-bg">
                  Thao tác
                </div>
              </div>
            </v-col>
            <v-col cols="12" v-if="!data.length">
              <p v-if="isLoading" class="text-center">Đang tải dữ liệu....</p>
              <p v-if="!isLoading" class="text-center">Không có dữ liệu</p>
            </v-col>
            <template v-if="data.length">
              <v-col cols="12" class="px-8 py-3" v-for="(item, indexGR) in data" :key="'gr-' + indexGR">
                <div class="item-product py-0">
                  <div class="d-flex product-info">
                    <div class="col-code px-2 text-left">
                      {{ item.code }}
                    </div>
										<div class="col-type px-2">
                      {{ item.type ? promotionTypeObject[item.type] : '' }}
                    </div>
										<div class="col-count-use px-2 text-center">
                      {{ item.type == promotionPrivate ? '--' : item.numberOfAvailable }}
                    </div>
										<div class="col-count px-2 text-center">
                      {{ item.type == promotionGeneral ? '--' : item.numberOfCode }}
                    </div>
										<div class="col-count-used px-2 text-center">
                      {{ item.numberOfUsed }}
                    </div>
                    <div class="col-action text-center">
                      <a class="link-edit" target="_blank" :href="`/promotion/detail/${item.id}`">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-eye
                            </v-icon>
                          </template>
                          <span>Xem chi tiết</span>
                        </v-tooltip>
                      </a>
                    </div>
                  </div>
                </div>
              </v-col>
            </template>
					</v-row>
				</div>
			</v-col>

			<v-col cols="12" v-if="totalPage">
				<v-row>
					<v-col offset="4" cols="8" class="py-0">
						<v-row>
							<v-col cols="7" class="d-flex justify-end py-0">
								<p class="pt-3">Rows per page:</p>
							</v-col>
							<v-col cols="1" class="justify-end py-0">
								<v-select
									class="text-field"
									:items="[{ id: 10 },{ id: 20 },{ id: 30 },{ id: 40 },{ id: 50 }]"
									item-value="id"
									item-text="id"
									:aLight="'right'"
									placeholder="Chọn"
									attach
									dense
									v-model="numPerPage"
									@change="getList(1)"
									:menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
								></v-select>
							</v-col>
							<v-col cols="1" class="justify-center py-0">
								<p class="pt-3 text-center">
									{{ (page - 1) * numPerPage + 1 }}-{{ (page - 1) * numPerPage + data.length }} of {{ totalItem }}
								</p>
							</v-col>
							<v-col cols="3" class="py-0">
								<v-pagination
									v-model="page"
									class="d-flex justify-end pagination-custom"
									:length="totalPage"
									:total-visible="7"
									@input="getList()"
								></v-pagination>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</div>
	</div>
</template>
  
<script>
import * as moment from "moment";

import {
	promotionTypes,
	promotionGeneral,
	promotionPrivate,
} from "../../helpers/constants";

import RepositoryFactory from "@/repositories/RepositoryFactory";
const PromotionRepository = RepositoryFactory.get("promotion");

import { formatDate } from "@/helpers/utils";

export default {
	name: "detail",
	components: {},
	props: {},
	data() {
		return {
			data: [],
			numPerPage: 20,
			page: 1,
			totalPage: null,
			totalItem: null,
			txtSearch: null,
			isLoading: false,
			promotionTypeObject: [],
			promotionTypes,
			promotionGeneral,
			promotionPrivate,
		};
	},
	computed: {
	},
	created() {
		this.getList();
		this.promotionTypes.forEach((item) => {
			this.promotionTypeObject[item.id] = item.name;
		});
	},
	beforeDestroy() {},
	methods: {
		compare(a, b) {
			if (b.id > a.id) {
				return 1;
			}
			if (a.id > b.id) {
				return -1;
			}
			return 0;
		},
		create() {
			this.$router.push('/promotion/create');
		},
		async getList(page = null) {
			if (page) {
				this.page = page;
			}
			const params = {
				page: this.page,
				limit: this.numPerPage,
				code: this.txtSearch,
			};
			this.isLoading = true;
			this.data = [];
			const res = await PromotionRepository.getList(params);
			this.isLoading = false;
			if (res.success) {
				this.data = res.data;
				this.totalItem = res.totalItem;
				this.totalPage = Math.ceil(res.totalItem / this.numPerPage);
			}
		}
	},
};
</script>
<style scoped lang="scss">
.btn-save {
	background: #8465ff !important;
	color: #fff;
}
.btn-cancel {
	background: #787878 !important;
	color: #fff;
}
.create-form {
	background: #fff;
}
.group-form {
	background: #fafbff;
	border-radius: 10px;
	box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
}
.text-bold {
	font-weight: bold;
}

.btn-info {
	background: #6587ff !important;
	color: #fff;
}

.icon-search {
	left: 40px;
	position: relative;
}
.table-custom {
	th {
		background: #e7e8ff;
		border-left: 1px solid #fff;
	}
}
.link-edit {
  text-decoration: none !important;
}
.box-header {
	position: sticky;
	top: 0px;
}
.col-bg {	
	background: #FAFBFF;
}
.box-header-table {
	position: sticky;
	top: 55px;
}
</style>
  
<style lang="scss">
.text-field fieldset {
	background: #fff !important;
}
.text-search {
	.v-input__slot {
		min-height: 20px !important;
		padding-left: 35px !important;
	}
}

.v-select-custom {
	.v-subheader {
		font-weight: bold;
		background: #ececec;
		color: #000;
	}
}

.group-bread-scrumb {
	position: relative;
	top: -30px;
	z-index: 99;
	height: 0;
	font-weight: bold;
	font-size: 17px;
	a {
		text-decoration: none !important;
		color: #000;
	}
}
.start-date-custom {
	.v-input__slot {
		background: #fff !important;
	}
}
.text-field-no-message {
	.v-text-field__details {
		display: none !important;
	}
}
.col-code {
	width: 20%;
}
.col-type {
	width: 15%;
}
.col-count-use {
	width: 15%;
}
.col-count {
	width: 10%;
}
.col-count-used {
	width: 10%;
}
.col-action {
	width: 10%;
}
.pagination-custom {
  li button{
    box-shadow: none !important;
		color: #3F51B5 !important;
  }

	.v-pagination__item--active {
		color: #000 !important;
		background: #fff !important;
	}
}

.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}
</style>
